const BASE_URL = process.env.REACT_APP_API_URL;

export const GOOGLE_RECAPTCHA_SITE_KEY = "6Lf5_goqAAAAANOw60WIun3u52Cmc1pAiedac9uB";
const ACCOUNT = "account/";
const USER = "user/";
const SUBSCRIBER = "subscriber/";
const REPORTS = "reports/";
const UI_TOOLS = "UITools/";
const ORGANIZATION_HANDLER = "organizationHandler/";
const INVOICE_HANDLER = "invoiceHandler/";
const SCHEDULE_REPORTS_HANDLER = "ScheduleReportsHandler/";
const POOL_USAGE_ALERT_HANDLER = "poolUsageAlertHandler/";
const ACCOUNT_HANDLER = "accountHandler/";
const SUBSCRIBER_HANDLER = "subscriberHandler/";
const PRO_RATION_HANDLER = "proRationHandler/";
const ATTACHMENTS_HANDLER = "attachmentsHandler/";
const CUSTOMER_HANDLER = "customerHandler/";
const ROLES = "roles/";
const PRIVILEGES = "privileges/";
const PARTNERS = "partners/";
const DX_PORTAL = "DXPortal/";
const TABLE_GENERATOR = "tableGenerator/";
const BILLING_CYCLES_HANDLER = "billingCyclesHandler/";
const USAGE_PRICING_PLAN_HANDLER = "usagePricingPlan/";
const DISCOUNT_HANDLER = "DiscountHandler/";
const RATE_PLAN_HANDLER = "ratePlanHandler/";
const TAX_HANDLER = "taxHandler/";
const RESOURCES_HANDLER = "resourcesHandler/";
const CARRIER_SUBSCRIBERS_HANDLER = "carrierSubscriberHandler/";
const NOTES = "notes/";
const TROUBLE_TICKETS = "troubleTickets/";
const POOL_HANDLER = "poolHandler/";
const JOBS_HANDLER = "jobsHandler/";
const TREATMENT_PLAN = "TreatmentPlan/";
const SALES_REPS = "salesReps/";
const CARRIER_PLANS_AND_FEATURES = "carrierPlansAndFeatures/";
const MDM_HANDLER = "MDMHandler/";
const TAC_MANAGEMENT_CONTROLLER = "api/tacManagement/";
const DEV_CONTROLLER = "devController/";
const ORDERS_CONTROLLER = "orders/";
const CUSTOMER_MESSAGES = "customerMessages/";
const THALES_CONTROLLER = "thales/";
const API_USAGE = "apiUsage/";
const EID_CONFIGURATION = "EIDConfiguration/";
const PAYMENT_CONTROLLER = "payment/";

export const globals = {
  login: {
    login: BASE_URL + "login",
  },
  logout: "https://pos.dataxoom.com",
  user: {
    getUserPrivileges: BASE_URL + USER + "privileges",
    deleteUser: BASE_URL + USER + "deleteUser",
    saveAccountUser: BASE_URL + USER + "saveAccountUser",
    saveUser: BASE_URL + USER + "saveUser",
    resetPassword: BASE_URL + USER + "resetPassword",
    forgotPassword: BASE_URL + USER + "forgotPassword",
    isMfaEnabled: BASE_URL + USER + "isMfaEnabled",
  },
  tableGenerator: BASE_URL + TABLE_GENERATOR + "tableData",
  accountDashboard: {
    top5: {
      top5Subscribers: BASE_URL + ACCOUNT + "top5/Subscribers",
      top5OrganizationUnits: BASE_URL + ACCOUNT + "top5/organizationUnits",
    },
    details: BASE_URL + ACCOUNT + "details",
    chartStats: {
      accountLast6Months: BASE_URL + ACCOUNT + "lastMonthsStats",
    },
    stats: {
      currentOverview: BASE_URL + ACCOUNT + "stats/CurrentOverview",
    },
    statements: {
      accountStatements: BASE_URL + ACCOUNT + "statements",
    },
    pools: {
      accountPools: BASE_URL + ACCOUNT + "pools",
    },
    financial: {
      transaction: BASE_URL + ACCOUNT + "financial/transactions",
    },
    invoices: {
      allInvoices: BASE_URL + ACCOUNT + "invoices/allInvoices",
    },
    scheduleReports: {
      allScheduleReports: BASE_URL + ACCOUNT + "scheduleReports/allScheduleReports",
    },
    search: {
      subscribers: BASE_URL + ACCOUNT + "search/subscribers",
    },
    dataLimitHistory: {
      dataLimitHistoryRecord: BASE_URL + ACCOUNT + "dataLimitHistoryRecord",
      universalDataLimitHistoryRecord: BASE_URL + ACCOUNT + "universalDataLimitHistoryRecord",
    },
    poolsUsageHistory: {
      poolsUsageAlertsHistory: BASE_URL + ACCOUNT + "poolsUsageHistory",
      poolUsageHistoryRecord: BASE_URL + ACCOUNT + "poolUsageHistoryRecord",
    },
    billingInvoices: {
      billingInvoicesPeriods: BASE_URL + ACCOUNT + "billingInvoicesPeriods",
    },
    ratePlans: {
      accountRatePlans: BASE_URL + ACCOUNT + "ratePlans",
      newSubscriberRatePlans: BASE_URL + ACCOUNT + "newSubscriberRatePlans",
    },
    poolUsageAlerts: {
      accountPoolUsageAlerts: BASE_URL + ACCOUNT + "poolUsageAlerts",
    },
    availableIccids: BASE_URL + ACCOUNT + "availableIccids",
    availableSimCardsByCarrier: BASE_URL + ACCOUNT + "availableSimCardsByCarrier",
    accountSubscriberSelection: BASE_URL + ACCOUNT + "accountSubscriberSelection",
    accountCycleStartDate: BASE_URL + ACCOUNT + "accountCycleStartDate",
    hasMaaS360: BASE_URL + ACCOUNT + "hasMaaS360",
    isCorporate: BASE_URL + ACCOUNT + "isCorporate",
    accountSIMCards: BASE_URL + ACCOUNT + "accountSIMCards",
    accountPools: BASE_URL + ACCOUNT + "accountPools",
    isMasterAccountAllowsPoolingAcrossAccounts: BASE_URL + ACCOUNT + "isMasterAccountAllowsPoolingAcrossAccounts",
    isFinalInvoiceEnable: BASE_URL + ACCOUNT + "isFinalInvoiceEnable",
    accountSubscriberFieldsData: BASE_URL + ACCOUNT + "accountSubscriberFieldsData",
    editAccountSubscriberFieldsData: BASE_URL + ACCOUNT + "editAccountSubscriberFieldsData",
    subscribersFieldsCustomNames: BASE_URL + ACCOUNT + "subscribersFieldsCustomNames",
    accountLogoDetails: BASE_URL + ACCOUNT + "accountLogoDetails",
  },
  subscriberDashboard: {
    details: {
      subscriberDetails: BASE_URL + SUBSCRIBER + "details",
    },
    device: {
      subscriberDeviceDetails: BASE_URL + SUBSCRIBER + "device",
      subscriberDeviceImage: BASE_URL + SUBSCRIBER + "device/itemPicture",
    },
    lastMonths: {
      lastMonthsStats: BASE_URL + SUBSCRIBER + "lastMonthsStats",
      lastMonthsDailyDataAndVoiceUsage: BASE_URL + SUBSCRIBER + "lastMonthsDailyDataAndVoiceUsage",
    },
    plan: {
      subscriberPlan: BASE_URL + SUBSCRIBER + "plan",
    },
    overview: {
      subscriberOverview: BASE_URL + SUBSCRIBER + "overview",
    },
    charges: {
      subscriberCharges: BASE_URL + SUBSCRIBER + "charges",
    },
    realTimeUsageData: BASE_URL + SUBSCRIBER + "realTimeUsageData",
    cycleDates: BASE_URL + SUBSCRIBER + "cycleDates",
    subDashboardCurrentMonth: BASE_URL + SUBSCRIBER + "subDashboardCurrentMonth",
    subscriberActiveDaysSinceLastActivation: BASE_URL + SUBSCRIBER + "subscriberActiveDaysSinceLastActivation",
    pendingOperationDetails: BASE_URL + SUBSCRIBER + "pendingOperationDetails",
    subscriberMdmData: BASE_URL + SUBSCRIBER + "subscriberMdmData",
    networkIMEI: BASE_URL + SUBSCRIBER + "networkIMEI",
    dataLimitHistoryRecord: BASE_URL + SUBSCRIBER + "dataLimitHistoryRecord",
    subscriberDateToChargeFrom: BASE_URL + SUBSCRIBER + "subscriberDateToChargeFrom",
    suspendReasons: BASE_URL + SUBSCRIBER + "suspendReasons",
    subscriberFieldsData: BASE_URL + SUBSCRIBER + "subscriberFieldsData",
    isDeviceConnected: BASE_URL + SUBSCRIBER + "isDeviceConnected",
    changeStatusProfiles: BASE_URL + SUBSCRIBER + "changeStatusProfiles",
    subscriberProfilesData: BASE_URL + SUBSCRIBER + "subscriberProfilesData",
  },
  reports: {
    reportList: BASE_URL + REPORTS + "reportList",
    getReport: BASE_URL + REPORTS + "getReport",
    blockUsers: BASE_URL + REPORTS + "blockUsers",
    getUserBlockedReports: BASE_URL + REPORTS + "getUserBlockedReports",
    accountReports: {
      currentAccountOverview: BASE_URL + REPORTS + "currentAccountSnapshot",
      previousAccountOverview: BASE_URL + REPORTS + "previousAccountSnapshot",
      lastYearAccountOverview: BASE_URL + REPORTS + "lastYearAccountSnapshot",
      twoMonthsBackAccountOverview: BASE_URL + REPORTS + "twoMonthsBackAccountSnapshot",
      accountMonthlyQuickSummary: BASE_URL + REPORTS + "accountMonthlyQuickSummary",
    },
    getAccountSnapshot: BASE_URL + REPORTS + "getAccountSnapshot",
    getAccountMonthlyQuickSummary: BASE_URL + REPORTS + "getAccountMonthlyQuickSummary",
    reportColumns: BASE_URL + REPORTS + "reportColumns",
    editReportColDescription: BASE_URL + REPORTS + "editReportColDescription",
    editReportDescription: BASE_URL + REPORTS + "editReportDescription",
    export: BASE_URL + REPORTS + "export",
  },
  partnersDashboard: {
    accounts: BASE_URL + PARTNERS + "accounts",
    top10: BASE_URL + PARTNERS + "top10",
    chartsDataDays: BASE_URL + PARTNERS + "chartsDataDays",
    chartsDataMonths: BASE_URL + PARTNERS + "chartsDataMonths",
    chartsDataYears: BASE_URL + PARTNERS + "chartsDataYears",
    newPartner: BASE_URL + PARTNERS + "newPartner",
    editPartner: BASE_URL + PARTNERS + "editPartner",
    deletePartner: BASE_URL + PARTNERS + "deletePartner",
    deletePartnerPlan: BASE_URL + PARTNERS + "deletePartnerPlan",
    savePartnerPlan: BASE_URL + PARTNERS + "savePartnerPlan",
  },
  DXPortal: {
    top10: {
      accounts: BASE_URL + DX_PORTAL + "top10/accounts",
      subscribers: BASE_URL + DX_PORTAL + "top10/subscribers",
    },
    chartsDataDays: BASE_URL + DX_PORTAL + "chartsDataDays",
    chartsDataMonths: BASE_URL + DX_PORTAL + "chartsDataMonths",
    chartsDataYears: BASE_URL + DX_PORTAL + "chartsDataYears",
  },
  UITools: {
    scheduledReports: BASE_URL + UI_TOOLS + "scheduledReports",
    frequencies: BASE_URL + UI_TOOLS + "frequencies",
    periods: BASE_URL + UI_TOOLS + "periods",
    orgUnits: BASE_URL + UI_TOOLS + "orgUnits",
    pools: BASE_URL + UI_TOOLS + "pools",
    accountActivePools: BASE_URL + UI_TOOLS + "accountActivePools",
    enumValues: BASE_URL + UI_TOOLS + "enumValues",
    getUSStates: BASE_URL + UI_TOOLS + "getUSStates",
    getAccountIndustries: BASE_URL + UI_TOOLS + "getAccountIndustries",
    getPlanAddOnList: BASE_URL + UI_TOOLS + "getPlanAddOnList",
    loadCarrierSubscriber: BASE_URL + UI_TOOLS + "loadCarrierSubscriber",
    loadCarrierSubscriberByIccid: BASE_URL + UI_TOOLS + "loadCarrierSubscriberByIccid",
    getCarrierInfo: BASE_URL + UI_TOOLS + "getCarrierInfo",
    activationConfigValues: BASE_URL + UI_TOOLS + "activationConfigValues",
    carriers: BASE_URL + UI_TOOLS + "carriers",
    simCarriers: BASE_URL + UI_TOOLS + "simCarriers",
    simCardSizes: BASE_URL + UI_TOOLS + "simCardSizes",
    auditDetails: BASE_URL + UI_TOOLS + "auditDetails",
    customerAuditDetails: BASE_URL + UI_TOOLS + "customerAuditDetails",
    languages: BASE_URL + UI_TOOLS + "languages",
    AccountCyclesForNewAdjustment: BASE_URL + UI_TOOLS + "AccountCyclesForNewAdjustment",
    accountRoles: BASE_URL + UI_TOOLS + "accountRoles",
    treatmentPlans: BASE_URL + UI_TOOLS + "treatmentPlans",
    invoiceLayouts: BASE_URL + UI_TOOLS + "invoiceLayouts",
    invoiceDeliveryModes: BASE_URL + UI_TOOLS + "invoiceDeliveryModes",
    invoiceFormats: BASE_URL + UI_TOOLS + "invoiceFormats",
    paymentTypes: BASE_URL + UI_TOOLS + "paymentTypes",
    MDMTypes: BASE_URL + UI_TOOLS + "MDMTypes",
    roles: BASE_URL + UI_TOOLS + "roles",
    groups: BASE_URL + UI_TOOLS + "groups",
    featuresTypes: BASE_URL + UI_TOOLS + "featuresTypes",
    offeringTypes: BASE_URL + UI_TOOLS + "offeringTypes",
    commissionTypes: BASE_URL + UI_TOOLS + "commissionTypes",
    allAccountRatePlans: BASE_URL + UI_TOOLS + "allAccountRatePlans",
    simActivationReadyStatusModes: BASE_URL + UI_TOOLS + "simActivationReadyStatusModes",
  },
  organizationHandler: {
    addOrEditOrganization: BASE_URL + ORGANIZATION_HANDLER + "save",
    deleteOrganization: BASE_URL + ORGANIZATION_HANDLER + "delete",
    organizationName: BASE_URL + ORGANIZATION_HANDLER + "organizationName",
    getOrganizationSelection: BASE_URL + ORGANIZATION_HANDLER + "organizationSelection",
  },
  ScheduleReportsHandler: {
    addOrEditScheduleReport: BASE_URL + SCHEDULE_REPORTS_HANDLER + "save",
    deleteScheduleReport: BASE_URL + SCHEDULE_REPORTS_HANDLER + "delete",
  },
  poolUsageAlertHandler: {
    addOrEditPoolUsageAlert: BASE_URL + POOL_USAGE_ALERT_HANDLER + "save",
    deletePoolUsageAlert: BASE_URL + POOL_USAGE_ALERT_HANDLER + "delete",
  },
  accountHandler: {
    accountCurrentEmail: BASE_URL + ACCOUNT_HANDLER + "accountCurrentEmail",
    changeEmail: BASE_URL + ACCOUNT_HANDLER + "changeEmail",
    changePassword: BASE_URL + ACCOUNT_HANDLER + "changePassword",
    changeTempPassword: BASE_URL + ACCOUNT_HANDLER + "changeTempPassword",
    autoPay: BASE_URL + ACCOUNT_HANDLER + "autoPay",
    changeAutoPayStatus: BASE_URL + ACCOUNT_HANDLER + "changeAutoPayStatus",
    financialTransactionInfo: BASE_URL + ACCOUNT_HANDLER + "financialTransactionInfo",
    startDateEarlierUnBilledCycle: BASE_URL + ACCOUNT_HANDLER + "startDateEarlierUnBilledCycle",
    maxAmountAccountCredit: BASE_URL + ACCOUNT_HANDLER + "maxAmountAccountCredit",
    approvedNotFullyPaidInvoices: BASE_URL + ACCOUNT_HANDLER + "approvedNotFullyPaidInvoices",
    saveAdjustment: BASE_URL + ACCOUNT_HANDLER + "saveAdjustment",
    deleteAdjustment: BASE_URL + ACCOUNT_HANDLER + "deleteAdjustment",
    uploadBulkActivations: BASE_URL + ACCOUNT_HANDLER + "uploadBulkActivations",
    createCreditNote: BASE_URL + ACCOUNT_HANDLER + "createCreditNote",
    deleteCreditNote: BASE_URL + ACCOUNT_HANDLER + "deleteCreditNote",
    deleteDebitNote: BASE_URL + ACCOUNT_HANDLER + "deleteDebitNote",
    createDebitNote: BASE_URL + ACCOUNT_HANDLER + "createDebitNote",
    makePayment: BASE_URL + ACCOUNT_HANDLER + "makePayment",
    cancelPayment: BASE_URL + ACCOUNT_HANDLER + "cancelPayment",
    deletePayment: BASE_URL + ACCOUNT_HANDLER + "deletePayment",
    deleteContact: BASE_URL + ACCOUNT_HANDLER + "deleteContact",
    saveContact: BASE_URL + ACCOUNT_HANDLER + "saveContact",
    dataLimitAlerts: BASE_URL + ACCOUNT_HANDLER + "dataLimitAlerts",
    saveDataLimitAlerts: BASE_URL + ACCOUNT_HANDLER + "saveDataLimitAlerts",
    MDMAlerts: BASE_URL + ACCOUNT_HANDLER + "MDMAlerts",
    saveMDMAlerts: BASE_URL + ACCOUNT_HANDLER + "saveMDMAlerts",
    deactivateAccount: BASE_URL + ACCOUNT_HANDLER + "deactivateAccount",
    createFinalInvoice: BASE_URL + ACCOUNT_HANDLER + "createFinalInvoice",
    createNewAccount: BASE_URL + ACCOUNT_HANDLER + "createNewAccount",
    editAccount: BASE_URL + ACCOUNT_HANDLER + "editAccount",
    accountInfo: BASE_URL + ACCOUNT_HANDLER + "accountInfo",
    isMasterAccount: BASE_URL + ACCOUNT_HANDLER + "isMasterAccount",
    hasMasterAccount: BASE_URL + ACCOUNT_HANDLER + "hasMasterAccount",
    accountPoolType: BASE_URL + ACCOUNT_HANDLER + "accountPoolType",
    universalDataLimitsData: BASE_URL + ACCOUNT_HANDLER + "universalDataLimitsData",
    editAccountUniversalDataLimitsData: BASE_URL + ACCOUNT_HANDLER + "editAccountUniversalDataLimitsData",
    templateDefaultFieldsValues: BASE_URL + ACCOUNT_HANDLER + "templateDefaultFieldsValues",
    saveTemplateDefaultFieldsValues: BASE_URL + ACCOUNT_HANDLER + "saveTemplateDefaultFieldsValues",
  },
  invoiceHandler: {
    getInvoice: BASE_URL + INVOICE_HANDLER + "invoice",
    resendInvoice: BASE_URL + INVOICE_HANDLER + "resendInvoice",
    regenerateInvoice: BASE_URL + INVOICE_HANDLER + "regenerateInvoice",
  },
  subscriberHandler: {
    subscriberViewDetails: BASE_URL + SUBSCRIBER_HANDLER + "subscriberViewDetails",
    dashboardUpdateSubscriberInfo: BASE_URL + SUBSCRIBER_HANDLER + "dashboardUpdateSubscriberInfo",
    dashboardUpdateSubscriberDetails: BASE_URL + SUBSCRIBER_HANDLER + "dashboardUpdateSubscriberDetails",
    sendRequestUpdateSubscriberInfo: BASE_URL + SUBSCRIBER_HANDLER + "sendRequestUpdateSubscriberInfo",
    subscriber2LastPeriods: BASE_URL + SUBSCRIBER_HANDLER + "subscriber2LastPeriods",
    subscriberUsageSummary: BASE_URL + SUBSCRIBER_HANDLER + "subscriberUsageSummary",
    updateUsageSummary: BASE_URL + SUBSCRIBER_HANDLER + "updateUsageSummary",
    subscriberSpendingLimit: BASE_URL + SUBSCRIBER_HANDLER + "subscriberSpendingLimit",
    updateSpendLimit: BASE_URL + SUBSCRIBER_HANDLER + "updateSpendLimit",
    changePlanDetails: BASE_URL + SUBSCRIBER_HANDLER + "changePlanDetails",
    subscriberRatePlansOptions: BASE_URL + SUBSCRIBER_HANDLER + "subscriberRatePlansOptions",
    getEndOfPeriod: BASE_URL + SUBSCRIBER_HANDLER + "getEndOfPeriod",
    changePlan: BASE_URL + SUBSCRIBER_HANDLER + "changePlan",
    deleteSubscriberSim: BASE_URL + SUBSCRIBER_HANDLER + "deleteSubscriberSim",
    addSubscriberProfile: BASE_URL + SUBSCRIBER_HANDLER + "addSubscriberProfile",
    enableSubscriberProfile: BASE_URL + SUBSCRIBER_HANDLER + "enableSubscriberProfile",
    cancelPendingEnableSubscriberProfileRequest:
      BASE_URL + SUBSCRIBER_HANDLER + "cancelPendingEnableSubscriberProfileRequest",
    phoneNumbers: BASE_URL + SUBSCRIBER_HANDLER + "phoneNumbers",
    isSubscriberAssignedToPlan: BASE_URL + SUBSCRIBER_HANDLER + "isSubscriberAssignedToPlan",
    carrierDetailsToFetch: BASE_URL + SUBSCRIBER_HANDLER + "carrierDetailsToFetch",
    carrierDetails: BASE_URL + SUBSCRIBER_HANDLER + "carrierDetails",
    changePhoneNumber: BASE_URL + SUBSCRIBER_HANDLER + "changePhoneNumber",
    changeImei: BASE_URL + SUBSCRIBER_HANDLER + "changeImei",
    assignCarrierSubscriber: BASE_URL + SUBSCRIBER_HANDLER + "assignCarrierSubscriber",
    deleteSubscriber: BASE_URL + SUBSCRIBER_HANDLER + "deleteSubscriber",
    removeDataLimitSentFlags: BASE_URL + SUBSCRIBER_HANDLER + "removeDataLimitSentFlags",
    addDataUsage: BASE_URL + SUBSCRIBER_HANDLER + "addDataUsage",
    changeCarrierPlan: BASE_URL + SUBSCRIBER_HANDLER + "changeCarrierPlan",
    changeCarrierFeatures: BASE_URL + SUBSCRIBER_HANDLER + "changeCarrierFeatures",
    presetData: BASE_URL + SUBSCRIBER_HANDLER + "presetData",
    sendSMS: BASE_URL + SUBSCRIBER_HANDLER + "sendSMS",
    SMSHistory: BASE_URL + SUBSCRIBER_HANDLER + "SMSHistory",
    subscriberSimData: BASE_URL + SUBSCRIBER_HANDLER + "subscriberSimData",
    unprocessedEnableProfileRequestData: BASE_URL + SUBSCRIBER_HANDLER + "unprocessedEnableProfileRequestData",
  },
  proRationHandler: {
    proRationDataByAccountId: BASE_URL + PRO_RATION_HANDLER + "proRationDataByAccountId",
  },
  attachmentsHandler: {
    itemPicture: BASE_URL + ATTACHMENTS_HANDLER + "itemPicture",
    tempPicture: BASE_URL + ATTACHMENTS_HANDLER + "tempPicture",
    getFile: BASE_URL + ATTACHMENTS_HANDLER + "getFile",
    getAccountCorporateFile: BASE_URL + ATTACHMENTS_HANDLER + "getAccountCorporateFile",
  },
  customerHandler: {
    getProrationData: BASE_URL + CUSTOMER_HANDLER + "getProrationData",
    userResume: BASE_URL + CUSTOMER_HANDLER + "userResume",
    userSuspend: BASE_URL + CUSTOMER_HANDLER + "userSuspend",
    resumeData: BASE_URL + CUSTOMER_HANDLER + "resumeData",
    refreshSim: BASE_URL + CUSTOMER_HANDLER + "refreshSim",
    disconnect: BASE_URL + CUSTOMER_HANDLER + "disconnect",
    swapSim: BASE_URL + CUSTOMER_HANDLER + "swapSim",
    activate: BASE_URL + CUSTOMER_HANDLER + "activate",
    reactivate: BASE_URL + CUSTOMER_HANDLER + "reactivate",
    manualActivation: BASE_URL + CUSTOMER_HANDLER + "manualActivation",
    cancelPendingRequest: BASE_URL + CUSTOMER_HANDLER + "cancelPendingRequest",
    deactivateDisconnectedCCIPLines: BASE_URL + CUSTOMER_HANDLER + "deactivateDisconnectedCCIPLines",
  },
  billingCyclesHandler: {
    billingCyclesPrograms: BASE_URL + BILLING_CYCLES_HANDLER + "billingCyclesPrograms",
    programBillingCycles: BASE_URL + BILLING_CYCLES_HANDLER + "programBillingCycles",
    accountBillingCycles: BASE_URL + BILLING_CYCLES_HANDLER + "accountBillingCycles",
    saveCycleProgram: BASE_URL + BILLING_CYCLES_HANDLER + "saveCycleProgram",
    sendCycleInvoices: BASE_URL + BILLING_CYCLES_HANDLER + "sendCycleInvoices",
  },
  usagePricingPlanHandler: {
    newOrEditUsagePlan: BASE_URL + USAGE_PRICING_PLAN_HANDLER + "newOrEditUsagePlan",
    deleteUsagePlan: BASE_URL + USAGE_PRICING_PLAN_HANDLER + "deleteUsagePlan",
    getUsagePlansByPool: BASE_URL + USAGE_PRICING_PLAN_HANDLER + "getUsagePlansByPool",
  },
  discountHandler: {
    newOrEditDiscount: BASE_URL + DISCOUNT_HANDLER + "newOrEditDiscount",
    deleteDiscount: BASE_URL + DISCOUNT_HANDLER + "deleteDiscount",
    discountsPlans: BASE_URL + DISCOUNT_HANDLER + "discountsPlans",
  },
  ratePlanHandler: {
    getRatePlan: BASE_URL + RATE_PLAN_HANDLER + "getRatePlan",
    getAddOns: BASE_URL + RATE_PLAN_HANDLER + "getAddOns",
    getNumberOfSuspendedOrActiveSubscriberInPlan:
      BASE_URL + RATE_PLAN_HANDLER + "getNumberOfSuspendedOrActiveSubscriberInPlan",
    deleteRatePlan: BASE_URL + RATE_PLAN_HANDLER + "deleteRatePlan",
    getRatePlanAvailabilityTypes: BASE_URL + RATE_PLAN_HANDLER + "getRatePlanAvailabilityTypes",
    getPlanNetworkFeatures: BASE_URL + RATE_PLAN_HANDLER + "getPlanNetworkFeatures",
    newRatePlan: BASE_URL + RATE_PLAN_HANDLER + "newRatePlan",
    editRatePlan: BASE_URL + RATE_PLAN_HANDLER + "editRatePlan",
    saveAccountRatePlan: BASE_URL + RATE_PLAN_HANDLER + "saveAccountRatePlan",
    deleteAccountRatePlan: BASE_URL + RATE_PLAN_HANDLER + "deleteAccountRatePlan",
    availablePlansList: BASE_URL + RATE_PLAN_HANDLER + "availablePlansList",
    accountPlanDefaultPool: BASE_URL + RATE_PLAN_HANDLER + "accountPlanDefaultPool",
  },
  taxHandler: {
    getAllTaxDiscountsByEntityIdAndType: BASE_URL + TAX_HANDLER + "getAllTaxDiscountsByEntityIdAndType",
    editTaxSettings: BASE_URL + TAX_HANDLER + "editTaxSettings",
    taxesUpload: BASE_URL + TAX_HANDLER + "taxesUpload",
  },
  resourcesHandler: {
    saveManufacture: BASE_URL + RESOURCES_HANDLER + "saveManufacture",
    deleteManufacture: BASE_URL + RESOURCES_HANDLER + "deleteManufacture",
    saveShipment: BASE_URL + RESOURCES_HANDLER + "saveShipment",
    deleteShipment: BASE_URL + RESOURCES_HANDLER + "deleteShipment",
    uploadStaticIp: BASE_URL + RESOURCES_HANDLER + "uploadStaticIp",
    saveStaticIp: BASE_URL + RESOURCES_HANDLER + "saveStaticIp",
    deleteStaticIp: BASE_URL + RESOURCES_HANDLER + "deleteStaticIp",
    bulkInsertSims: BASE_URL + RESOURCES_HANDLER + "bulkInsertSims",
    bulkUpdateSims: BASE_URL + RESOURCES_HANDLER + "bulkUpdateSims",
    accountSimAssignment: BASE_URL + RESOURCES_HANDLER + "accountSimAssignment",
    bulkThalesSimUpload: BASE_URL + RESOURCES_HANDLER + "bulkThalesSimUpload",
    checkIfExistDifferentSim: BASE_URL + RESOURCES_HANDLER + "checkIfExistDifferentSim",
    saveSimScan: BASE_URL + RESOURCES_HANDLER + "saveSimScan",
    deleteSim: BASE_URL + RESOURCES_HANDLER + "deleteSim",
    saveSim: BASE_URL + RESOURCES_HANDLER + "saveSim",
    deleteDeviceType: BASE_URL + RESOURCES_HANDLER + "deleteDeviceType",
    isItemPicExists: BASE_URL + RESOURCES_HANDLER + "isItemPicExists",
    editTacItemData: BASE_URL + RESOURCES_HANDLER + "editTacItemData",
    uploadTempDevicePicture: BASE_URL + RESOURCES_HANDLER + "uploadTempDevicePicture",
    saveDeviceType: BASE_URL + RESOURCES_HANDLER + "saveDeviceType",
    deleteDevice: BASE_URL + RESOURCES_HANDLER + "deleteDevice",
    deviceStore: BASE_URL + RESOURCES_HANDLER + "deviceStore",
    esnStatusList: BASE_URL + RESOURCES_HANDLER + "esnStatusList",
    vendorList: BASE_URL + RESOURCES_HANDLER + "vendorList",
    saveDevice: BASE_URL + RESOURCES_HANDLER + "saveDevice",
    device: BASE_URL + RESOURCES_HANDLER + "device",
    uploadDevices: BASE_URL + RESOURCES_HANDLER + "uploadDevices",
    reprocessDevicesFile: BASE_URL + RESOURCES_HANDLER + "reprocessDevicesFile",
    fileImportStatus: BASE_URL + RESOURCES_HANDLER + "fileImportStatus",
    corporateResourcesFiles: BASE_URL + RESOURCES_HANDLER + "corporateResourcesFiles",
    uploadAccountCorporateResourceFile: BASE_URL + RESOURCES_HANDLER + "uploadAccountCorporateResourceFile",
    deleteAccountCorporateResourceFile: BASE_URL + RESOURCES_HANDLER + "deleteAccountCorporateResourceFile",
    deleteTempResourcesFolder: BASE_URL + RESOURCES_HANDLER + "deleteTempResourcesFolder",
    getLPAQrCode: BASE_URL + RESOURCES_HANDLER + "getLPAQrCode",
    getLPAQrCodeByIccid: BASE_URL + RESOURCES_HANDLER + "getLPAQrCodeByIccid",
    bulkUploadEids: BASE_URL + RESOURCES_HANDLER + "bulkUploadEids",
    updateSimsActivationReadyStatus: BASE_URL + RESOURCES_HANDLER + "updateSimsActivationReadyStatus",
  },
  carrierSubscriberHandler: {
    uploadCarrierSubscribers: BASE_URL + CARRIER_SUBSCRIBERS_HANDLER + "uploadCarrierSubscribers",
    uploadCarrierSubscribersLastDXDisconnectDate:
      BASE_URL + CARRIER_SUBSCRIBERS_HANDLER + "uploadCarrierSubscribersLastDXDisconnectDate",
    deleteCarrierSubscriber: BASE_URL + CARRIER_SUBSCRIBERS_HANDLER + "deleteCarrierSubscriber",
    saveCarrierSubscriber: BASE_URL + CARRIER_SUBSCRIBERS_HANDLER + "saveCarrierSubscriber",
    carrierSubscriberBySubscriberId: BASE_URL + CARRIER_SUBSCRIBERS_HANDLER + "carrierSubscriberBySubscriberId",
  },
  roles: {
    allRoles: BASE_URL + ROLES + "allRoles",
    rolePrivilegesById: BASE_URL + ROLES + "role",
    updateRole: BASE_URL + ROLES + "updateRole",
    addRole: BASE_URL + ROLES + "addRole",
    deleteRole: BASE_URL + ROLES + "deleteRole",
    accountRoles: BASE_URL + ROLES + "accountRoles",
    addRolesToAccount: BASE_URL + ROLES + "addRolesToAccount",
    redirectForDashboard: BASE_URL + ROLES + "redirectForDashboard",
    updateAccountScope: BASE_URL + ROLES + "updateAccountScope",
  },
  privileges: {
    allPrivileges: BASE_URL + PRIVILEGES + "allPrivileges",
    allPrivilegesByRoleIdOrderBySecurityID: BASE_URL + PRIVILEGES + "allPrivilegesByRoleId",
  },
  notes: {
    saveNote: BASE_URL + NOTES + "saveNote",
    deleteNote: BASE_URL + NOTES + "deleteNote",
  },
  troubleTickets: {
    sendMail: BASE_URL + TROUBLE_TICKETS + "sendMail",
    ticketTypesList: BASE_URL + TROUBLE_TICKETS + "ticketTypesList",
    assignedToList: BASE_URL + TROUBLE_TICKETS + "assignedToList",
    statusList: BASE_URL + TROUBLE_TICKETS + "statusList",
    saveTroubleTicket: BASE_URL + TROUBLE_TICKETS + "saveTroubleTicket",
  },
  pools: {
    savePool: BASE_URL + POOL_HANDLER + "savePool",
    deletePool: BASE_URL + POOL_HANDLER + "deletePool",
  },
  jobs: {
    bulkOperation: BASE_URL + JOBS_HANDLER + "bulkOperation",
    reprocessBulkOperation: BASE_URL + JOBS_HANDLER + "reprocessBulkOperation",
    uploadBulkRequests: BASE_URL + JOBS_HANDLER + "uploadBulkRequests",
  },
  treatmentPlans: {
    getTreatmentPlanRules: BASE_URL + TREATMENT_PLAN + "getTreatmentPlanRules",
    saveTreatmentPlan: BASE_URL + TREATMENT_PLAN + "saveTreatmentPlan",
  },
  salesReps: {
    saveSalesRep: BASE_URL + SALES_REPS + "saveSalesRep",
    deleteSalesRep: BASE_URL + SALES_REPS + "delete",
  },
  carrierPlansAndFeatures: {
    saveCarrierPlanOrFeature: BASE_URL + CARRIER_PLANS_AND_FEATURES + "saveCarrierPlanOrFeature",
    deleteCarrierPlanOrFeature: BASE_URL + CARRIER_PLANS_AND_FEATURES + "deleteCarrierPlanOrFeature",
  },
  MDMHandler: {
    approveAll: BASE_URL + MDM_HANDLER + "approveAll",
    approveSelected: BASE_URL + MDM_HANDLER + "approveSelected",
    disapproveAll: BASE_URL + MDM_HANDLER + "disapproveAll",
    disapproveSelected: BASE_URL + MDM_HANDLER + "disapproveSelected",
    delete: BASE_URL + MDM_HANDLER + "delete",
  },
  TacManagementController: {
    save: BASE_URL + TAC_MANAGEMENT_CONTROLLER + "save",
    delete: BASE_URL + TAC_MANAGEMENT_CONTROLLER + "delete",
    upload: BASE_URL + TAC_MANAGEMENT_CONTROLLER + "upload",
  },
  dev: {
    jobs: BASE_URL + DEV_CONTROLLER + "jobs",
    disableAllJobs: BASE_URL + DEV_CONTROLLER + "disableAllJobs",
    enableAllJobs: BASE_URL + DEV_CONTROLLER + "enableAllJobs",
    enableJob: BASE_URL + DEV_CONTROLLER + "enableJob",
    scheduledJobs: BASE_URL + DEV_CONTROLLER + "scheduledJobs",
    runScheduleJob: BASE_URL + DEV_CONTROLLER + "runScheduleJob",
    saveReport: BASE_URL + DEV_CONTROLLER + "saveReport",
    bulkUpdateColumnsDescriptions: BASE_URL + DEV_CONTROLLER + "bulkUpdateColumnsDescriptions",
  },
  orders: {
    createdOrderDetails: BASE_URL + ORDERS_CONTROLLER + "createdOrderDetails",
    originalOrderData: BASE_URL + ORDERS_CONTROLLER + "originalOrderData",
    templateNotes: BASE_URL + ORDERS_CONTROLLER + "templateNotes",
    saveTemplateNotes: BASE_URL + ORDERS_CONTROLLER + "saveTemplateNotes",
    exportOriginalOrderFile: BASE_URL + ORDERS_CONTROLLER + "exportOriginalOrderFile",
    exportOrderActivationTemplate: BASE_URL + ORDERS_CONTROLLER + "exportOrderActivationTemplate",
    exportFailedRowsActivationTemplate: BASE_URL + ORDERS_CONTROLLER + "exportFailedRowsActivationTemplate",
    saveTemplateRatePlans: BASE_URL + ORDERS_CONTROLLER + "saveTemplateRatePlans",
    templateRatePlans: BASE_URL + ORDERS_CONTROLLER + "templateRatePlans",
    templatePlansData: BASE_URL + ORDERS_CONTROLLER + "templatePlansData",
    exportAllOrderLines: BASE_URL + ORDERS_CONTROLLER + "exportAllOrderLines",
  },
  customerMessages: {
    saveCustomerMessage: BASE_URL + CUSTOMER_MESSAGES + "saveCustomerMessage",
    testCustomerMessage: BASE_URL + CUSTOMER_MESSAGES + "testCustomerMessage",
  },
  thales: {
    newEnableProfileOrder: BASE_URL + THALES_CONTROLLER + "newEnableProfileOrder",
    validateNewEnableProfileOrder: BASE_URL + THALES_CONTROLLER + "validateNewEnableProfileOrder",
    deleteEnableProfileOrder: BASE_URL + THALES_CONTROLLER + "deleteEnableProfileOrder",
    eidEnableProfileOrders: BASE_URL + THALES_CONTROLLER + "eidEnableProfileOrders",
    newDownloadProfileOrder: BASE_URL + THALES_CONTROLLER + "newDownloadProfileOrder",
    cancelEnableProfileOrder: BASE_URL + THALES_CONTROLLER + "cancelEnableProfileOrder",
  },
  apiUsage: {
    getApiUsage: BASE_URL + API_USAGE + "getAPIUsage",
    getTop5APIS: BASE_URL + API_USAGE + "getTop5APIS",
  },
  eidConfiguration: {
    saveEIDConfiguration: BASE_URL + EID_CONFIGURATION + "saveEIDConfiguration",
    deleteEIDConfiguration: BASE_URL + EID_CONFIGURATION + "deleteEIDConfiguration",
  },
  payment: {
    getHostedToken: BASE_URL + PAYMENT_CONTROLLER + "getHostedToken",
    savePaymentMethod: BASE_URL + PAYMENT_CONTROLLER + "savePaymentMethod",
    deletePaymentMethod: BASE_URL + PAYMENT_CONTROLLER + "deletePaymentMethod",
    info: BASE_URL + PAYMENT_CONTROLLER + "info",
    creditCardNumber: BASE_URL + PAYMENT_CONTROLLER + "creditCardNumber",
  },
};
